import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentmumbai() {



    const cardData = {

keyword: "Tempo Traveller On Rent Mumbai",

headingDescription:
    "Mumbai Airport Cab offers spacious and affordable Tempo Traveller On Rent Mumbai services for family vacations, corporate tours, wedding transportation, group outings, pilgrimage journeys, airport transfers, and outstation trips. Our well-maintained Tempo Travellers are available in multiple seating capacities and come with comfortable pushback seats, ample luggage space, air-conditioning, and professional chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup and drop, and flexible rental packages, we ensure a safe, convenient, and enjoyable group travel experience across Mumbai and long-distance destinations.",

topPlaces: [
    {
        title: "Dwarka",
        description:
            "Dwarka is one of the most sacred Char Dham pilgrimage destinations in India and is home to the famous Dwarkadhish Temple. Large families and pilgrimage groups frequently book Tempo Travellers from Mumbai for a comfortable long-distance spiritual journey with ample space for passengers and luggage."
    },
    {
        title: "Somnath",
        description:
            "Somnath is renowned for the historic Somnath Jyotirlinga Temple located along the Arabian Sea coast. Group travelers prefer Tempo Traveller rentals for this route as they provide comfortable seating, smooth highway travel, and a convenient pilgrimage experience."
    },
    {
        title: "Hampi",
        description:
            "Hampi is a UNESCO World Heritage Site known for its magnificent ruins, ancient temples, and unique stone landscapes. Tempo Travellers are ideal for group sightseeing tours, allowing travelers to explore the vast heritage region comfortably."
    },
    {
        title: "Pench National Park",
        description:
            "Pench National Park is famous for its tiger safaris, rich wildlife, and natural beauty. Families and adventure groups often hire Tempo Travellers for a relaxed and enjoyable journey to this popular wildlife destination."
    },
    {
        title: "Rann of Kutch",
        description:
            "The White Rann of Kutch is one of India's most extraordinary travel destinations, known for its vast salt desert and cultural festivals. Tempo Travellers are widely preferred for group road trips to experience the region comfortably."
    },
    {
        title: "Gir National Park",
        description:
            "Gir National Park is the only natural habitat of Asiatic lions in the world. Wildlife enthusiasts and family groups frequently choose Tempo Travellers for convenient travel and ample space during their safari adventure."
    },
    {
        title: "Shringeri",
        description:
            "Shringeri is a revered pilgrimage destination in Karnataka known for the Sharada Peetham and spiritual significance. Group devotees often book Tempo Travellers for a peaceful and comfortable religious tour from Mumbai."
    },
    {
        title: "Badami",
        description:
            "Badami is famous for its ancient cave temples, sandstone cliffs, and historical monuments. Tempo Traveller rentals are a practical option for groups exploring Karnataka’s rich architectural heritage."
    },
    {
        title: "Polo Forest",
        description:
            "Polo Forest in Gujarat is known for its dense forests, ancient temples, trekking trails, and natural beauty. It is a popular destination for family picnics, nature trips, and group weekend getaways from Mumbai."
    },
    {
        title: "Pachmarhi",
        description:
            "Pachmarhi, known as the Queen of Satpura, is a beautiful hill station in Madhya Pradesh featuring waterfalls, caves, forests, and viewpoints. Tempo Travellers offer a comfortable and enjoyable travel option for large groups visiting this scenic destination."
    }
],



services: [
{
name: "Tempo Traveller On Rent Mumbai",
description: "Mumbai Airport Cab offers Tempo Traveller On Rent Mumbai service for comfortable and convenient group transportation across Mumbai and outstation destinations. Our fleet includes luxury Tempo Travellers with comfortable pushback seats, spacious interiors, air-conditioning, ample luggage capacity, and modern travel amenities suitable for family vacations, corporate events, weddings, religious tours, airport transfers, sightseeing trips, school excursions, and long-distance journeys. With professional chauffeurs, transparent pricing, doorstep pickup and drop facilities, flexible travel schedules, and 24x7 customer support, we ensure safe, reliable, and enjoyable travel for groups of all sizes. Whether you need transportation for a single day, weekend getaway, or extended tour package, our Tempo Traveller rental service provides comfort, convenience, and value throughout the journey."
},
{
name: "Mumbai Tempo Traveller Rental",
description: "Mumbai Airport Cab provides Mumbai Tempo Traveller Rental service with well-maintained luxury vehicles designed for group travel, holiday tours, family outings, corporate transportation, wedding functions, pilgrimage journeys, and outstation trips. Our Tempo Travellers offer spacious seating arrangements, comfortable interiors, luggage space, and professional chauffeur service for smooth travel experiences. We focus on safety, punctuality, transparent pricing, flexible itineraries, and customer satisfaction to ensure every group enjoys a comfortable and stress-free journey across Mumbai and beyond."
},
{
name: "Hire Tempo Traveller Mumbai",
description: "Hire Tempo Traveller Mumbai through Mumbai Airport Cab for reliable group transportation suitable for family gatherings, business travel, educational tours, wedding events, sightseeing excursions, airport transfers, and long-distance road trips. Our vehicles are equipped with comfortable seating, air-conditioned cabins, ample storage space, and experienced chauffeurs who prioritize passenger safety and comfort. We provide customized travel solutions, affordable rental plans, and dedicated customer support to meet diverse travel requirements."
},
{
name: "Mumbai Group Travel Cab",
description: "Mumbai Group Travel Cab service by Mumbai Airport Cab is ideal for families, friends, corporate teams, tourists, and social groups requiring spacious and comfortable transportation. Our Tempo Traveller vehicles are perfect for local travel, sightseeing tours, airport transfers, destination weddings, religious tours, and outstation holidays. We offer professional drivers, flexible schedules, transparent rates, and reliable travel support to ensure every group journey remains safe, comfortable, and enjoyable."
},
{
name: "Tempo Traveller Booking Mumbai",
description: "Mumbai Airport Cab offers Tempo Traveller Booking Mumbai with simple reservation procedures, instant confirmation, flexible travel plans, and professional customer assistance. Whether you need transportation for family vacations, business events, airport transfers, group tours, or special occasions, our luxury Tempo Travellers provide comfort, safety, and convenience. We ensure timely service, well-maintained vehicles, experienced chauffeurs, and hassle-free booking experiences for every customer."
},
{
name: "Mumbai Tourist Tempo Traveller",
description: "Mumbai Tourist Tempo Traveller service provides comfortable transportation for sightseeing tours, holiday packages, city excursions, beach tours, hill station visits, and multi-day travel itineraries. Mumbai Airport Cab offers spacious Tempo Travellers with comfortable seating, large windows, air-conditioned interiors, and experienced drivers familiar with popular tourist destinations. We help travellers enjoy memorable and convenient journeys while exploring Mumbai and nearby attractions."
},
{
name: "Mumbai Outstation Tempo Traveller",
description: "Book Mumbai Outstation Tempo Traveller with Mumbai Airport Cab for comfortable long-distance travel to destinations such as Pune, Goa, Mahabaleshwar, Shirdi, Nashik, Lonavala, Aurangabad, and other tourist locations. Our Tempo Travellers are designed for highway travel with spacious seating, luggage capacity, air-conditioning, and professional chauffeur service. We provide customized itineraries, transparent pricing, and reliable transportation for family tours, group vacations, and corporate outings."
},
{
name: "12 Seater Tempo Traveller Mumbai",
description: "Mumbai Airport Cab provides 12 Seater Tempo Traveller Mumbai service for small groups seeking affordable and comfortable transportation. Ideal for family trips, corporate travel, sightseeing tours, airport transfers, and weekend getaways, our 12-seater vehicles offer comfortable seating, ample luggage space, air-conditioning, and professional driver service. We ensure safe, convenient, and enjoyable travel experiences for every group journey."
},
{
name: "17 Seater Tempo Traveller Mumbai",
description: "17 Seater Tempo Traveller Mumbai service is perfect for medium-sized groups travelling for weddings, pilgrimage tours, family vacations, educational trips, corporate events, and sightseeing excursions. Mumbai Airport Cab offers spacious vehicles equipped with comfortable seats, air-conditioning, luggage storage, and experienced chauffeurs. Our focus on safety, comfort, punctuality, and customer satisfaction ensures a smooth travel experience throughout the journey."
},
{
name: "20 Seater Tempo Traveller Mumbai",
description: "Mumbai Airport Cab offers 20 Seater Tempo Traveller Mumbai service for larger groups requiring comfortable and efficient transportation. Suitable for corporate outings, destination weddings, family reunions, school trips, religious tours, and holiday travel, our spacious vehicles provide excellent seating capacity, luggage space, air-conditioning, and professional chauffeur assistance. We ensure reliable transportation and enjoyable group travel experiences."
},
{
name: "Tempo Traveller Wedding Mumbai",
description: "Tempo Traveller Wedding Mumbai service provides organized transportation solutions for wedding guests, family members, bridal parties, and event attendees. Mumbai Airport Cab offers spacious and comfortable Tempo Travellers that help manage group transportation efficiently while ensuring timely arrivals and departures. With professional chauffeurs, clean vehicles, and flexible travel arrangements, we support smooth wedding transportation for every celebration."
},
{
name: "Tempo Traveller Corporate Mumbai",
description: "Mumbai Airport Cab provides Tempo Traveller Corporate Mumbai service for employee transportation, business meetings, corporate outings, conferences, airport transfers, and company events. Our spacious vehicles offer comfortable seating, professional chauffeur service, punctual operations, and reliable transportation support. We help organizations manage group travel efficiently while maintaining high standards of safety, convenience, and professionalism."
},
{
name: "Tempo Traveller Airport Transfer Mumbai",
description: "Tempo Traveller Airport Transfer Mumbai service offers convenient group transportation to and from Mumbai's domestic and international airport terminals. Mumbai Airport Cab provides spacious Tempo Travellers with ample luggage capacity, professional chauffeurs, flight monitoring support, and timely pickup and drop services. We ensure smooth airport transfers for families, tourists, corporate groups, and event travellers."
},
{
name: "Tempo Traveller Family Trip Mumbai",
description: "Mumbai Airport Cab offers Tempo Traveller Family Trip Mumbai service for families planning vacations, religious tours, sightseeing excursions, destination weddings, and weekend getaways. Our spacious vehicles provide comfortable seating, luggage space, air-conditioning, and professional driver assistance. We focus on delivering safe, enjoyable, and memorable travel experiences for families travelling together."
},
{
name: "Tempo Traveller Hill Station Mumbai",
description: "Tempo Traveller Hill Station Mumbai service is ideal for group trips to destinations such as Lonavala, Khandala, Mahabaleshwar, Panchgani, Matheran, and other scenic hill stations. Mumbai Airport Cab provides comfortable vehicles, experienced chauffeurs, flexible itineraries, and reliable transportation support. We ensure travellers enjoy relaxing journeys while exploring popular hill station destinations around Maharashtra."
},
{
name: "Tempo Traveller Tour Package Mumbai",
description: "Book Tempo Traveller Tour Package Mumbai with Mumbai Airport Cab for customized travel itineraries covering tourist attractions, pilgrimage destinations, holiday resorts, beaches, hill stations, and cultural landmarks. Our luxury Tempo Travellers provide comfort, convenience, spacious seating, and professional chauffeur service. We deliver well-planned travel experiences designed to meet the needs of families, groups, and corporate travellers."
},
{
name: "Tempo Traveller One Day Hire Mumbai",
description: "Mumbai Airport Cab provides Tempo Traveller One Day Hire Mumbai service for customers requiring group transportation for a full day of sightseeing, business activities, family functions, weddings, educational tours, or social events. Our well-maintained vehicles, professional drivers, and flexible schedules ensure comfortable and efficient travel throughout the day while offering excellent value and dependable service."
},
{
name: "Tempo Traveller Round Trip Mumbai",
description: "Tempo Traveller Round Trip Mumbai service offers convenient return transportation for family vacations, corporate outings, pilgrimage tours, sightseeing trips, wedding functions, and group events. Mumbai Airport Cab provides spacious vehicles, experienced chauffeurs, flexible scheduling, and transparent pricing. We ensure passengers enjoy safe, comfortable, and hassle-free travel from departure to return while maintaining high standards of service quality."
}
],

tableData: [
["Tempo Traveller On Rent Mumbai","Mumbai Tempo Traveller Rental"],
["Hire Tempo Traveller Mumbai","Mumbai Group Travel Cab"],
["Tempo Traveller Booking Mumbai","Mumbai Tourist Tempo Traveller"],
["Mumbai Outstation Tempo Traveller","12 Seater Tempo Traveller Mumbai"],
["17 Seater Tempo Traveller Mumbai","20 Seater Tempo Traveller Mumbai"],
["Tempo Traveller Wedding Mumbai","Tempo Traveller Corporate Mumbai"],
["Tempo Traveller Airport Transfer Mumbai","Tempo Traveller Family Trip Mumbai"],
["Tempo Traveller Hill Station Mumbai","Tempo Traveller Tour Package Mumbai"],
["Tempo Traveller One Day Hire Mumbai","Tempo Traveller Round Trip Mumbai"]
],


whychoose: [
    {
        WhyChooseheading: "Reliable Tempo Traveller on Rent in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Tempo Traveller Rental Services in Mumbai for family tours, corporate outings, airport transfers, weddings, pilgrimages, and group travel."
    },
    {
        WhyChooseheading: "Perfect Solution for Group Transportation",
        WhyChoosedescription: "Tempo Travellers are ideal for groups seeking comfortable travel with spacious seating, ample luggage capacity, and convenient long-distance transportation."
    },
    {
        WhyChooseheading: "Suitable for Family Trips and Vacations",
        WhyChoosedescription: "Whether planning a holiday, weekend getaway, religious tour, or family function, our Tempo Travellers offer comfortable travel for every occasion."
    },
    {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription: "Customers can choose Tempo Travellers with various seating configurations to accommodate small groups, large families, corporate teams, and tour groups."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Travel",
        WhyChoosedescription: "Our Tempo Traveller services are available for Mumbai city tours as well as destinations like Pune, Shirdi, Nashik, Mahabaleshwar, Goa, Lonavala, and other locations."
    },
    {
        WhyChooseheading: "Airport Transfer Services for Groups",
        WhyChoosedescription: "We provide convenient airport pickup and drop services for large families, corporate teams, tourists, and group travelers arriving at Mumbai Airport."
    },
    {
        WhyChooseheading: "Experienced Drivers for Safe Journeys",
        WhyChoosedescription: "Our professional drivers ensure safe driving, route expertise, punctual service, and a comfortable travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Corporate Events and Tours",
        WhyChoosedescription: "Many companies, educational institutions, wedding planners, and tour organizers choose our Tempo Travellers for group transportation requirements."
    }
]
};

const faqData = [
    {
        question: "Why choose Tempo Traveller on Rent in Mumbai?",
        answer: "Tempo Travellers offer spacious seating, comfortable interiors, luggage space, and are ideal for group travel, family trips, and corporate outings."
    },
    {
        question: "Can I book a Tempo Traveller for Mumbai Airport transfers?",
        answer: "Yes, Tempo Travellers are available for airport pickup and drop services for families, corporate teams, and tourist groups."
    },
    {
        question: "Is Tempo Traveller available for outstation trips?",
        answer: "Yes, customers can hire Tempo Travellers for Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Lonavala, Ahmedabad, and many other destinations."
    },
    {
        question: "Can Tempo Travellers be booked for family tours?",
        answer: "Yes, family vacations, religious tours, weddings, and group outings are among the most popular uses of Tempo Traveller rentals."
    },
    {
        question: "Do you provide Tempo Travellers for corporate travel?",
        answer: "Yes, corporate events, employee outings, conferences, and team travel can be arranged using our Tempo Traveller services."
    },
    {
        question: "Are chauffeur-driven Tempo Travellers available?",
        answer: "Yes, all Tempo Traveller rentals include experienced and professional drivers."
    },
    {
        question: "Can I book a Tempo Traveller for Mumbai Darshan?",
        answer: "Yes, customers can hire Tempo Travellers for Mumbai sightseeing tours, city travel, and customized itineraries."
    },
    {
        question: "Is advance booking recommended for Tempo Traveller rentals?",
        answer: "Yes, advance booking is recommended, especially during holidays, weekends, wedding seasons, and peak travel periods."
    },
    {
        question: "Can I book one-way and round-trip Tempo Traveller services?",
        answer: "Yes, one-way transfers, round trips, multi-day tours, and customized travel packages are available."
    },
    {
        question: "How can I book a Tempo Traveller on Rent in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ritesh Patil",
        feedback:
            "Our group of friends booked a Tempo Traveller for a weekend trip and the experience was fantastic. The vehicle was spacious, comfortable, and perfect for long-distance travel.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Deepali Shah",
        feedback:
            "Mumbai Airport Cabs arranged a Tempo Traveller for our family pilgrimage tour. The vehicle was well-maintained, the driver was professional, and the entire journey was very comfortable.",
        rating: 5
    }
];









































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Tempo Traveller on Rent Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/tempo-traveller-on-rent-mumbai.jpg",
"description": "Book Tempo Traveller on rent in Mumbai for group travel, family tours, corporate trips, weddings, and outstation journeys. Mumbai Airport Cabs offers spacious Tempo Traveller vehicles with professional drivers, comfortable seating, and reliable 24x7 service.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/tempo-traveller-on-rent-mumbai"
}
};






    return (
        <div>



<Helmet>
  <title>Tempo Traveller on Rent Mumbai | Group Travel Cab | +91 9545731161</title>

<meta
 name="description"
 content="Book Tempo Traveller on rent in Mumbai for group tours, family trips, weddings, and corporate travel. Spacious and comfortable vehicles with professional drivers and 24x7 service."
/>

<meta
 name="keywords"
 content="tempo traveller on rent mumbai, mumbai tempo traveller rental, hire tempo traveller mumbai, mumbai group travel cab, tempo traveller mumbai, tempo traveller booking mumbai, mumbai tempo traveller cab service, tempo traveller for family mumbai, tempo traveller for group mumbai, mumbai outstation tempo traveller, mumbai airport tempo traveller"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravelleronrentmumbai;